var map = {
	"./img/ABC.svg": 64274,
	"./img/EUROSKLEP.svg": 45782,
	"./img/EURO_SKLEP.svg": 62005,
	"./img/GROSZEK.svg": 99695,
	"./img/M_SKLEPY.png": 58362,
	"./img/drs/application-device.svg": 10663,
	"./img/drs/arrow.svg": 10141,
	"./img/drs/bag-all.svg": 29170,
	"./img/drs/bag-glass.svg": 67395,
	"./img/drs/bag-metal.svg": 83378,
	"./img/drs/bag-mix.svg": 7729,
	"./img/drs/bag-plastic.svg": 59063,
	"./img/drs/bank.svg": 12580,
	"./img/drs/blik.svg": 24564,
	"./img/drs/cash-device.svg": 27550,
	"./img/drs/cash.svg": 92687,
	"./img/drs/collections.svg": 9969,
	"./img/drs/credit-card.svg": 76084,
	"./img/drs/europlatform.svg": 19252,
	"./img/drs/glass-bag.svg": 76775,
	"./img/drs/glass.svg": 14562,
	"./img/drs/kaucyjni.svg": 43768,
	"./img/drs/location-mapping.svg": 15966,
	"./img/drs/mastercard.svg": 36538,
	"./img/drs/metal-bag.svg": 53774,
	"./img/drs/metal.svg": 883,
	"./img/drs/mix-bag.svg": 25073,
	"./img/drs/mix.svg": 24236,
	"./img/drs/mobile.svg": 66676,
	"./img/drs/operators.svg": 15089,
	"./img/drs/panel-device.svg": 63479,
	"./img/drs/plastic-bag-full.svg": 14407,
	"./img/drs/plastic-bag.svg": 35919,
	"./img/drs/plastic.svg": 78458,
	"./img/drs/przelewy24.svg": 62532,
	"./img/drs/reports.svg": 43179,
	"./img/drs/rvm-device.svg": 9798,
	"./img/drs/settings.svg": 48181,
	"./img/drs/stores.svg": 36496,
	"./img/drs/tutorial-mobile.svg": 49143,
	"./img/drs/tutorial.svg": 4196,
	"./img/drs/visa.svg": 20605,
	"./img/labels-thank-you.svg": 29358,
	"./img/login.svg": 5253,
	"./img/my-business/advertising-materials.svg": 21917,
	"./img/my-business/agreement-template.svg": 29441,
	"./img/my-business/announcements.svg": 7646,
	"./img/my-business/contract-template-operational-manual.svg": 59499,
	"./img/my-business/drs.svg": 17711,
	"./img/my-business/loan.svg": 73712,
	"./img/my-business/newspaper-materials.svg": 14194,
	"./img/my-business/operations-manual.svg": 49571,
	"./img/my-business/partners-council.svg": 35325,
	"./img/my-business/purchasing-group-equal-in-business.svg": 17716,
	"./img/my-business/retr.svg": 84031,
	"./img/my-business/retrodiscounts-services-manual.svg": 86750,
	"./img/my-business/terms-of-business.svg": 37042,
	"./img/notifications.svg": 95074,
	"./img/promo-adv.png": 5583,
	"./img/reports/service-2.svg": 51822,
	"./img/services/service-1.svg": 28736,
	"./img/services/service-2.svg": 19475,
	"./img/services/service-3.svg": 5250,
	"./img/services/service-4.svg": 14541,
	"./img/welcome-ep.jpg": 60898,
	"./img/welcome-mpromo.jpg": 1963,
	"./loader.svg": 4583,
	"./logo-ep-white.svg": 18303,
	"./logo-ep.svg": 53711,
	"./logo-mpromo-white.svg": 57202,
	"./logo-mpromo.svg": 74198,
	"./manifest-ep": 27422,
	"./manifest-ep.json": 27422,
	"./manifest-mpromo": 81137,
	"./manifest-mpromo.json": 81137
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50290;